module.exports = __webpack_public_path__ + "img/propertyoffice2.7b74f1e4.png";